import de from './de.json'

const messages: Record<string, Record<string, string>> = { de }
const defaultLang = 'de'

export { messages, defaultLang }
